import {mapActions, mapGetters} from 'vuex'

export const monitorMixin = {
  computed: {
    ...mapGetters({
      'renderHealth': 'monitor/renderHealth',
      'renderBots': 'monitor/renderBots'
    })
  },
  methods: {
    ...mapActions({
      'getRenderHealth': 'monitor/getRenderHealth',
      'getRenderBots': 'monitor/getRenderBots'
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/monitorMixin.js